<template>
	<transition>
		<div class="login-box">
			<div class="login-box__img-wrap slide">
				<transition name="view-leave">
					<img v-if="image" :key="image.id" class="login-box__img" :src="image.src" alt="image.alt">
				</transition>
			</div>
		</div>
	</transition>
</template>

<script>
import { getImagesAsset } from '@/config/util';

export default {
	data () {
		return {
			index: 0,
			image: null,
			images: [{
				id: 1,
				src: getImagesAsset('__demo/login/login_01.jpg'),
				alt: ''
			},
			{
				id: 2,
				src: getImagesAsset('__demo/login/login_02.jpg'),
				alt: ''
			},
			{
				id: 3,
				src: getImagesAsset('__demo/login/login_03.jpg'),
				alt: ''
			},
			{
				id: 4,
				src: getImagesAsset('__demo/login/login_04.jpg'),
				alt: ''
			}
			]
		};
	},
	mounted() {
		this.switchImage();
	},
	methods: {
		switchImage() {
			const retrievedObject = localStorage.getItem('imageObject');

			if (retrievedObject) {
				const index = parseInt(retrievedObject);
				this.image = this.images[index];
				const newindex = parseInt(retrievedObject) + 1;
				if (this.images.length === newindex) {
					localStorage.setItem('imageObject', '0');
				} else {
					localStorage.setItem('imageObject', JSON.stringify(newindex));
				}
			} else {
				localStorage.setItem('imageObject', '0');
				this.image = this.images[0];
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.view-leave-active {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease;
}

.view-enter-active {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease;
    transition-delay: 0.5s;
}

.view-enter, .view-leave-to {
    opacity: 0;
}

.view-enter-to, .view-leave {
    opacity: 1;
}

.login-box {
	position: relative;
	flex: 0 0 54%;
    max-width: 54%;
    width: 100%;

	@include mq($lg) {
		display: none;
	}
}
	.login__box--image {
		z-index: 0;

		&.show {
			&::before {
				width: 50vw;
			}
		}
	}

	.login-box__img {
		position: relative;
		z-index: 1;
		max-width: 100%;
		width: 100%;
		height: 100vh;
		object-fit: cover;
	}

	.login-box__img-wrap {
		position: relative;
		width: 100%;
		max-width: 100%;
		height: 100%;
	}
</style>
